// store.js
import { configureStore } from "@reduxjs/toolkit";
import articleCodeMPReducer from "./articlecodemp-slice";
import openLinkReducer from "./openlink-slice";
import articlesReducer from "./articlesSlice";
import authReducer from "./authSlice";
import redirectsReducer from "./redirectsSlice"; // Добавляем импорт
import mpArticleReducer from "./mpArticleSlice";
import { sitemapMiddleware } from "./sitemapMiddleware";

const store = configureStore({
  reducer: {
    openlink: openLinkReducer,
    articleCodeMP: articleCodeMPReducer,
    articles: articlesReducer,
    auth: authReducer,
    redirects: redirectsReducer, // Добавляем редюсер
    mpArticle: mpArticleReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(sitemapMiddleware),
});

window.store = store;

export default store;
